import styled, { css } from 'styled-components';
import { getThemeMedia } from '../../ds/components/helpers';
export const UseOverlayComponent = styled.div `
	display: none;
	position: fixed;
	top: ${({ topGap }) => topGap || 0}px;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 400;
	background-color: var(--neutral-black-15);

	@media screen {
		@media (min-width: ${getThemeMedia('medium')}) {
			${({ showOverlay }) => showOverlay &&
    css `
					display: block;
				`}
		}
	}
`;
//# sourceMappingURL=styles.js.map